import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { fetchonevehicle, vehicleSelector } from '../api/vehicles';
import TripDetailsCard from '../Listpage/TripDetailsCard';
import Gwagon from '../../src/Images/Gwagon.jpg';
import { FaUser, FaUserCheck, FaUserTimes, FaCarSide } from 'react-icons/fa';
import Seat from '../../src/Images/f8fa29b5-027c-4e02-93b5-8ecfaef9fb9a-removebg-preview.png'
import { fetchoneroute_details, routeSelector } from '../api/route';
import { KeyUri } from '../key'
import { fetchpricingmodal, pricingSelector } from '../api/pricesetting';
import { fetchUserTerms, termsSelector } from '../api/termsSlice';
import { trackEvent } from "../utils/metaPixel";

function getMetaCookie(name) {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : null;
}

function getFbc() {
  let fbc = getMetaCookie("_fbc");
  if (!fbc) {
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get("fbclid");
    if (fbclid) {
      fbc = `fb.1.${Date.now()}.${fbclid}`;
      document.cookie = `_fbc=${fbc}; path=/; max-age=${90 * 24 * 60 * 60}`;
    }
  }
  return fbc;
}

const SeatList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { vid } = useParams();

  const termsState = useSelector(termsSelector);
  const { currentTerms } = termsState;

  useEffect(() => { dispatch(fetchUserTerms()); }, [dispatch]);

  const { current_vehicle } = useSelector(vehicleSelector);
  const [seats, setSeats] = useState([]);
  const [tripdata, set_trip_data] = useState();
  const [passengers, setPassengers] = useState({});
  const [mainPassenger, setMainPassenger] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { selected_route, current_route } = useSelector(routeSelector);
  const [ride_date, set_ride_date] = useState();
  const [pricing_obj, setPricing_obj] = useState({});
  const retrievedData = JSON.parse(localStorage.getItem('Selected Data'));
  const [seatPrice, set_seat_price] = useState();
  const { currentPricing } = useSelector(pricingSelector);
  const selectedSeats = seats.filter(s => s.isSelected);
  const totalAmount = selectedSeats.reduce((sum, seat) => sum + seat.price, 0);
  const [gst, setgst] = useState();
  const [profit, setprofit] = useState();
  const [couponCode, setCouponCode] = useState('');
  const [couponMessage, setCouponMessage] = useState('');
  const [isCouponValid, setIsCouponValid] = useState(false);
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [discountedAmount, setDiscountedAmount] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [totalAmountToPay, setTotalAmountToPay] = useState(0);

  
  const [paymentGateway, setPaymentGateway] = useState('razorpay');

  const authUser = useSelector((state) => state.userauth?.user);
  const config = {
    headers: { Authorization: `Bearer ${authUser?.token}`, "Content-Type": "application/json" },
  };

  
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    const fetchVehicle = async () => {
      try {
        await dispatch(fetchonevehicle(vid));
        await dispatch(fetchpricingmodal());
        await dispatch(fetchoneroute_details(retrievedData));
        setLoading(false);
      } catch (error) {
        setError("Failed to load vehicle details");
        setLoading(false);
      }
    };
    fetchVehicle();
  }, [dispatch, vid]);

  useEffect(() => { setPricing_obj(currentPricing?.[0]); }, [currentPricing]);

  useEffect(() => {
    const formattedDate = new Date(retrievedData?.date)?.toISOString();
    set_ride_date(formattedDate);
  }, [retrievedData]);

  const toggleTermsModal = () => setShowTermsModal(!showTermsModal);

  const getprice = useCallback(
    (car) => {
      if (!car || !pricing_obj || !current_route) return 0;
      if (pricing_obj.pricing_model === "Driver Fixed") {
        const routePricing = car.selected_schedules?.find((r) => {
          const routeId = typeof r.route === "string" ? r.route : r.route?._id;
          return routeId === current_route._id;
        });
        if (!routePricing) return 0;
        const perTripPrice = Number(routePricing.price_per_Trip?.$numberDecimal || routePricing.price_per_Trip || 0);
        const perSeatPrice = perTripPrice / (car.capacity - 1);
        return perSeatPrice + perSeatPrice * (pricing_obj.platform_price / 100);
      }
      if (pricing_obj.pricing_model === "Admin Fixed") {
        const key = car.category === "Economy" ? "price_for_economy"
          : car.category === "Luxury" ? "price_for_luxary" : "price_for_premium";
        const base = Number(current_route[key]?.$numberDecimal) || 0;
        return base + base * (pricing_obj.platform_price / 100);
      }
      return 0;
    },
    [pricing_obj, current_route]
  );

  useEffect(() => {
    if (!current_vehicle) return;
    const perSeatPrice = getprice(current_vehicle);
    set_seat_price(perSeatPrice);
    setSeats((prevSeats) =>
      (current_vehicle.seats || []).map((seatId, index) => ({
        id: seatId,
        isSelected: prevSeats[index]?.isSelected || false,
        isBooked: (current_vehicle.booked_seats || []).includes(seatId),
        price: perSeatPrice,
      }))
    );
  }, [current_vehicle, current_route, pricing_obj]);

  useEffect(() => {
    const fetchTrip = async () => {
      try {
        const responseaa = await axios.post(`${KeyUri.BACKEND_URI}/get-trip`, {
          vehicleId: vid,
          rideDate: ride_date,
        });
        set_trip_data(responseaa?.data);
      } catch (error) {
        console.error("Error fetching trip:", error);
      }
    };
    fetchTrip();
  }, [vid, ride_date]);

  useEffect(() => {
    if (currentPricing) {
      setgst((currentPricing?.[0]?.gst_price) / 100);
      setprofit((currentPricing?.[0]?.platform_price) / 100);
    }
  }, [currentPricing, seatPrice]);

  const handleSeatClick = (id) => {
    if (seats.find(s => s.id === id)?.isBooked) return;
    setSeats(prev => prev.map(seat => seat.id === id ? { ...seat, isSelected: !seat.isSelected } : seat));
    setPassengers(prev => {
      const updated = { ...prev };
      if (updated[id]) delete updated[id];
      else updated[id] = { name: '', email: '', phone: '', gender: '' };
      return updated;
    });
  };

  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) { setCouponMessage("Please enter a coupon code."); setIsCouponValid(false); return; }
    const token = JSON.parse(localStorage.getItem("tokenUser"));
    const userIdToSend = authUser ? authUser._id : null;
    try {
      const response = await axios.post(
        `${KeyUri.BACKEND_URI}/redeem-coupon`,
        { userId: userIdToSend, couponCode: couponCode.trim(), total: totalAmount, bookingDate: Date.now(), tripDate: new Date(ride_date) },
        { headers: { Accept: "application/json", Authorization: token ? `Bearer ${token}` : "" } }
      );
      if (response.data.success) {
        setIsCouponValid(true);
        setCouponMessage(response.data.message || "Coupon applied successfully!");
        setCouponDiscount(response.data.discountAmount || 0);
        setAppliedCoupon({ ...response.data, discountAmount: response.data.discountAmount || 0, discount_type: response.data.discount_type });
      } else {
        setIsCouponValid(false); setCouponDiscount(0);
        setCouponMessage(response.data.message || "This coupon is not valid for this user.");
      }
    } catch (error) {
      setIsCouponValid(false); setCouponDiscount(0);
      setCouponMessage(error.response?.data?.message || "This coupon is not valid for this user.");
    }
  };

  const getFinalPaymentDetails = () => {
    const baseAmount = totalAmount;
    let couponDeduction = 0;
    if (appliedCoupon?.discount_type === 'percentage') {
      couponDeduction = (couponDiscount / 100) * baseAmount;
    } else if (appliedCoupon?.discount_type === 'fixed') {
      couponDeduction = couponDiscount;
    }
    couponDeduction = Math.min(couponDeduction, baseAmount);
    const discountedAmount = baseAmount - couponDeduction;
    const taxAmount = discountedAmount * gst;
    const totalPayable = discountedAmount + taxAmount;
    return {
      totalFare: baseAmount.toFixed(2),
      couponDeduction: couponDeduction.toFixed(2),
      taxAmount: taxAmount.toFixed(2),
      totalPayable: totalPayable.toFixed(2),
    };
  };

  
  const handlePayment = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("tokenUser"));
      const fareDetails = getFinalPaymentDetails();
      const uniqueArr = [...new Set(selectedSeats?.map((seat) => seat.id) || [])];

        const eventId = crypto.randomUUID();
    trackEvent("InitiateCheckout", {
      content_ids: [current_vehicle?._id],
      content_type: "cab_booking",
      value: Number(fareDetails.totalPayable),
      currency: "INR",
      num_items: uniqueArr.length,
    }, eventId);

     const { data } = await axios.post(`${KeyUri.BACKEND_URI}/payment/create-order`, {
        amount: fareDetails.totalPayable,
        mainPassenger,
        passengers,
        vehicle: current_vehicle?._id,
        route: current_route?._id,
        selectedSeats: uniqueArr,
        ride_date_and_time: ride_date,
        pickup_point: retrievedData?.pickupStreet,
        drop_point: retrievedData?.dropStreet,
        paymentGateway,
        eventId,
        fbc: getFbc(),
        fbp: getMetaCookie("_fbp"),
      }, {
        headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
      });
if (paymentGateway === 'cashfree') {
  const cashfreeData = data?.data || data;

  const orderId = cashfreeData?.order_id || cashfreeData?.orderId;
  const paymentSessionId =
    cashfreeData?.payment_session_id || cashfreeData?.paymentSessionId;

  if (!paymentSessionId) {
    console.error("Cashfree session missing:", data);
    alert("Unable to open Cashfree payment page.");
    return;
  }

        sessionStorage.setItem("cashfree_ride_event_id", eventId);
      sessionStorage.setItem("cashfree_ride_value", fareDetails.totalPayable);
      sessionStorage.setItem("cashfree_ride_vehicle_id", current_vehicle?._id || "");

  if (!window.Cashfree) {
    await new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.body.appendChild(s);
    });
  }

  const cashfree = window.Cashfree({
    mode:
      process.env.REACT_APP_CASHFREE_ENV === "PRODUCTION"
        ? "production"
        : "sandbox",
  });

  await cashfree.checkout({
    paymentSessionId,
    redirectTarget: "_self",
  });

  return;
  } else if (paymentGateway === 'hdfc') {
  const hdfcData = data?.data || data;
  const paymentUrl = hdfcData?.payment_url;

  if (!paymentUrl) {
    console.error("HDFC payment_url missing:", data);
    alert("Unable to open HDFC payment page.");
    return;
  }

  sessionStorage.setItem("hdfc_ride_event_id", eventId);
  sessionStorage.setItem("hdfc_ride_value", fareDetails.totalPayable);
  sessionStorage.setItem("hdfc_ride_vehicle_id", current_vehicle?._id || "");

  window.location.href = paymentUrl; // leaves the React app
  return;

} else {
       
        const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY_ID;
        if (!razorpayKey) {
          alert("Payment gateway is not configured properly.");
          return;
        }
        const options = {
          key: razorpayKey,
          amount: data?.data?.amount,
          currency: data?.data?.currency,
          name: "The Great Himalayas",
          description: "Test Transaction",
          order_id: data?.data?.id,
          handler: async function (response) {
            alert(`Payment Successful! Payment ID: ${response.razorpay_payment_id}`);
              trackEvent("Purchase", {
            value: Number(fareDetails.totalPayable),
            currency: "INR",
            content_ids: [current_vehicle?._id],
            content_type: "cab_booking",
            content_name: "Shared Cab Ride",
          }, eventId);
          
            window.location.href = `/sharedcabbookingconfirmed?paymentId=${response.razorpay_payment_id}&rideid=${data?.dataa?._id}`;
          },
          prefill: {
            name: passengers[mainPassenger]?.name || "",
            email: passengers[mainPassenger]?.email || "",
            contact: passengers[mainPassenger]?.phone || "",
          },
          theme: { color: "#3399CC" },
        };
        const rzp = new window.Razorpay(options);
        rzp.open();
      }
    } catch (error) {
      console.error("Error in payment:", error);
      alert("Payment failed. Please try again.");
    }
  };

  const validateForm = () => {
    if (selectedSeats.length === 0) return "Please select at least one seat";
    if (!mainPassenger) return "Please select a main passenger";
    const main = passengers[mainPassenger];
    if (!main?.name || !main?.phone) return "Main passenger details incomplete";
    if (main.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(main.email)) return "Invalid email format";
    if (!/^\d{10}$/.test(main.phone)) return "Invalid phone number (must be 10 digits)";
    if (main.gender === 'Other' && !main.customGender) return "Please specify gender for 'Other' selection";
    return null;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const error = validateForm();
    if (error) return setError(error);
    setError(null);
    setShowModal(true);
  };

  if (loading) return <div className="text-center py-8">Loading...</div>;
  if (!current_vehicle) return <div className="text-center py-8">Vehicle not found</div>;

  const bookedSeats = tripdata?.bookedSeats?.flatMap(booking => booking.seatNumbers) || [];
  const totalPassengerSeats = (tripdata?.totalSeats || 0) - 1;
  const availableSeats = Math.max(0, totalPassengerSeats - bookedSeats.length);

  return (
    <div className="mx-auto flex flex-col lg:flex-row gap-8 p-4 max-w-7xl mb-14 mt-16 lg:mt-32 font-lato">

      {/* Terms & Conditions Modal */}
      {showTermsModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={toggleTermsModal}>
          <div className="bg-white rounded-lg shadow-lg max-w-xl w-full p-6 relative" onClick={(e) => e.stopPropagation()}>
            <h3 className="text-lg font-bold mb-4">Terms and Conditions</h3>
            <div className="max-h-64 overflow-y-auto text-sm text-gray-700 space-y-2">
              {currentTerms && <div dangerouslySetInnerHTML={{ __html: currentTerms }} className="prose max-w-none" />}
            </div>
            <div className="mt-4 text-right">
              <button onClick={toggleTermsModal} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Close</button>
            </div>
          </div>
        </div>
      )}

      <div className="w-full lg:w-2/3 space-y-8">
        <TripDetailsCard vehicle={current_vehicle} />
        <div className="bg-white shadow-md rounded-lg p-3 sm:p-6 flex items-center gap-3 sm:gap-4 w-full max-w-sm sm:max-w-md pr-5px md:ml-[11.5rem]">
          <img src={current_vehicle?.picture_of_the_vehicle} alt={current_vehicle?.brand_name + '' + current_vehicle?.model_name} className="w-24 h-24 sm:w-32 sm:h-32 object-cover rounded-md" />
          <div className="flex flex-col flex-grow">
            <h3 className="text-md sm:text-lg font-bold">{current_vehicle?.brand_name}</h3>
            <h3 className="text-md sm:text-lg font-bold">{current_vehicle?.model_name}</h3>
            <p className="text-gray-600 text-xs sm:text-sm">{current_vehicle.seats?.length} Seater</p>
            <p className="text-blue-600 font-bold text-md sm:text-lg mt-1">₹{getprice(current_vehicle)}/seat</p>
          </div>
        </div>
      </div>

      <div className="w-full lg:w-1/3 space-y-6">
        <div className="flex justify-center items-center w-full">
          <div className="w-1/2 flex flex-col items-center">
            <h2 className="text-lg font-semibold mb-4">Vehicle Layout</h2>
            <div className="mb-4 flex justify-center">
              <img src={current_vehicle?.loadout_image} alt="Seat Layout" className="w-full max-w-md" />
            </div>
          </div>
        </div>

        {tripdata ? (
          <div className="bg-white shadow-lg rounded-lg overflow-hidden">
            <div className="bg-blue-100 p-4">
              <h2 className="text-lg font-semibold">Available Seats ({availableSeats} remaining)</h2>
            </div>
            <div className="p-4 grid grid-cols-2 gap-4">
              {(() => {
                const bookedSeats = tripdata?.bookedSeats.flatMap(booking => booking.seatNumbers);
                const seats = Array.from({ length: tripdata?.totalSeats }, (_, index) => {
                  const seatId = index === 0 ? 'D1' : `S${index}`;
                  return { id: seatId, isBooked: bookedSeats.includes(seatId), isSelected: false };
                });
                const displaySeats = [...seats];
                if (displaySeats.length > 0) { const d1 = displaySeats.shift(); displaySeats.splice(1, 0, d1); }
                return displaySeats.map(seat => (
                  <button key={seat.id} onClick={() => handleSeatClick(seat.id)}
                    disabled={seat.isBooked || seat.id === "D1"}
                    className={`p-4 rounded text-center font-semibold ${seat.id === "D1" ? 'bg-gray-300 text-white cursor-not-allowed'
                      : seat.isSelected ? 'bg-blue-600 text-white'
                        : seat.isBooked ? 'bg-red-500 text-white cursor-not-allowed'
                          : 'bg-gray-100 hover:bg-blue-100'}`}>
                    {seat.id}
                  </button>
                ));
              })()}
            </div>
          </div>
        ) : (
          <div className="bg-white shadow-lg rounded-lg overflow-hidden">
            <div className="bg-blue-100 p-4">
              <h2 className="text-lg font-semibold">Available Seats ({seats.filter(s => !s.isBooked && s.id !== "D1").length} remaining)</h2>
            </div>
            <div className="p-4 grid grid-cols-2 gap-4">
              {(() => {
                const displaySeats = [...seats];
                if (displaySeats.length > 0) { const d1 = displaySeats.shift(); displaySeats.splice(1, 0, d1); }
                return displaySeats.map(seat => (
                  <button key={seat.id} onClick={() => handleSeatClick(seat.id)}
                    disabled={seat.isBooked || seat.id === "D1"}
                    className={`p-4 rounded text-center font-semibold ${seat.id === "D1" ? 'bg-gray-300 text-white cursor-not-allowed'
                      : seat.isSelected ? 'bg-blue-600 text-white'
                        : seat.isBooked ? 'bg-red-500 text-white cursor-not-allowed'
                          : 'bg-gray-100 hover:bg-blue-100'}`}>
                    {seat.id}
                  </button>
                ));
              })()}
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit} className="bg-gray-50 p-6 rounded-lg shadow mx-auto">
          <h2 className="text-2xl font-semibold mb-6">Passenger Details</h2>
          {error && <div className="text-red-500 mb-4">{error}</div>}

          {selectedSeats.length === 0 && (
            <div className="bg-yellow-100 border-l-4 border-yellow-400 text-yellow-700 p-3 rounded-lg shadow-md mt-4">
              <p className="font-semibold text-center text-lg mb-2">No seats selected!</p>
              <p className="text-center text-sm mb-3">Please select seats for the trip before proceeding.</p>
              <div className="bg-white rounded-md shadow-sm border space-y-4 flex flex-col">
                <input type="text" placeholder='Enter Your Name' disabled className="w-full border border-gray-300 rounded-md shadow-sm px-3" />
              </div>
            </div>
          )}

          <div className="w-full overflow-x-auto">
            <div className="grid grid-cols-1 gap-6">
              {Object.entries(passengers).map(([seatId, passenger]) => (
                <div key={seatId} className="bg-white p-4 rounded-md shadow-sm border w-full max-w-full">
                  <h3 className="text-lg font-medium mb-4">Seat {seatId}</h3>
                  <input type="text" placeholder="Name" value={passenger.name}
                    onChange={e => {
                      const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                      setPassengers(prev => ({ ...prev, [seatId]: { ...prev[seatId], name: onlyLetters } }));
                    }}
                    className="w-full mb-4 p-2 border rounded" required />
                  <label className="block mb-4">
                    <input type="checkbox" checked={mainPassenger === seatId}
                      onChange={() => setMainPassenger(prev => (prev === seatId ? null : seatId))}
                      className="mr-2" />
                    Main Passenger
                  </label>
                  {mainPassenger === seatId && (
                    <>
                      <input type="email" placeholder="Email" value={passenger.email}
                        onChange={e => setPassengers(prev => ({ ...prev, [seatId]: { ...prev[seatId], email: e.target.value } }))}
                        className="w-full mb-4 p-2 border rounded" />
                      <input type="tel" placeholder="Phone" value={passenger.phone}
                        onChange={e => setPassengers(prev => ({ ...prev, [seatId]: { ...prev[seatId], phone: e.target.value } }))}
                        className="w-full mb-4 p-2 border rounded" pattern="\d{10}" required />
                      <small className="text-xs text-gray-500 mb-2 -mt-3 block">* Do not enter country code or leading 0. Example: 9876543210</small>
                    </>
                  )}
                  <div className="space-y-2">
                    <label>Gender:</label>
                    <div className="flex flex-wrap gap-4">
                      {['Male', 'Female', 'Other'].map(gender => (
                        <label key={gender} className="block">
                          <input type="radio" name={`gender-${seatId}`} value={gender}
                            checked={passenger.gender === gender}
                            onChange={e => setPassengers(prev => ({ ...prev, [seatId]: { ...prev[seatId], gender: e.target.value, customGender: e.target.value === 'Other' ? '' : undefined } }))}
                            className="mr-2" />
                          {gender}
                        </label>
                      ))}
                    </div>
                    {passenger.gender === 'Other' && (
                      <input type="text" placeholder="Specify Gender" value={passenger.customGender || ''}
                        onChange={e => setPassengers(prev => ({ ...prev, [seatId]: { ...prev[seatId], customGender: e.target.value } }))}
                        className="w-full p-2 border rounded mt-2" required />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Coupon */}
          <div className="bg-white p-4 mt-6 rounded-md shadow-sm border">
            <h3 className="text-lg font-medium mb-2">Apply Coupon</h3>
            <div className="flex flex-col md:flex-row gap-4">
              <input type="text" placeholder="Enter Coupon Code" value={couponCode}
                onChange={(e) => { setCouponCode(e.target.value); setCouponMessage(""); }}
                className="flex-1 p-2 border rounded" />
              <button type="button" onClick={handleApplyCoupon} className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">Apply</button>
            </div>
            {couponMessage && <p className={`mt-2 text-sm ${isCouponValid ? 'text-green-600' : 'text-red-600'}`}>{couponMessage}</p>}
          </div>

          {/* ── Payment gateway selector ──────────────────────────────────── */}
          <div className="bg-white p-4 mt-4 rounded-md shadow-sm border">
            <h3 className="text-lg font-medium mb-3">Payment Method</h3>
                  <div className="flex gap-6">
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="radio" name="gateway" value="razorpay"
                  checked={paymentGateway === 'razorpay'}
                  onChange={() => setPaymentGateway('razorpay')} />
                <span className="font-medium">Razorpay</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="radio" name="gateway" value="cashfree"
                  checked={paymentGateway === 'cashfree'}
                  onChange={() => setPaymentGateway('cashfree')} />
                <span className="font-medium">Cashfree</span>
              </label>
            {/*}  <label className="flex items-center gap-2 cursor-pointer">
                <input type="radio" name="gateway" value="hdfc"
                  checked={paymentGateway === 'hdfc'}
                  onChange={() => setPaymentGateway('hdfc')} />
                <span className="font-medium">HDFC Bank</span>
              </label>*/}
            </div>
          </div>

          <div className="mt-4 flex items-start gap-2 text-sm text-gray-700">
            <input type="checkbox" id="couponTerms" checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)} className="mt-1" />
            <label htmlFor="couponTerms">
              I agree to the{' '}
              <button type="button" onClick={toggleTermsModal} className="text-blue-600 underline hover:text-blue-800">Terms & Conditions</button>
            </label>
          </div>

          <button type="submit" disabled={selectedSeats.length === 0 || !termsAccepted}
            className={`mt-6 w-full py-2 rounded font-semibold ${selectedSeats.length === 0 || !termsAccepted ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`}>
            Proceed to Payment
          </button>
        </form>
      </div>

      {showModal && (() => {
        const fareDetails = getFinalPaymentDetails();
        return (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg p-6 max-w-md w-full">
              <h3 className="text-xl font-bold mb-4">Confirm Booking</h3>
              <p className="mb-2"><strong>Selected Seats:</strong> {selectedSeats.map(s => s.id).join(', ')}</p>
              <p className="mb-2"><strong>Total Fare:</strong> ₹{fareDetails.totalFare}</p>
              <p className="mb-2"><strong>Coupon Discount:</strong> -₹{fareDetails.couponDeduction}</p>
              <p className="mb-2"><strong>GST:</strong> ₹{fareDetails.taxAmount}</p>
              <p className="mb-2 text-gray-500 text-sm"><strong>Payment via:</strong> <span className="capitalize">{paymentGateway}</span></p>
              <p className="mb-2 font-bold"><strong>Amount Payable:</strong> ₹{fareDetails.totalPayable}</p>
              <div className="flex justify-end gap-4">
                <button onClick={() => setShowModal(false)} className="px-4 py-2 border rounded">Cancel</button>
                <button onClick={handlePayment} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Confirm Payment</button>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
};

export default SeatList;